<template>
  <div class="container-fluid">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <div class="row mb-4">
      <div class="col-sm-5 col-lg-4">
        <div class="card display-info position-relative">
          <div class="card-body">
            <div class="download-container" v-click-outside="closeExport">
              <img
                src="../../assets/images/download.svg"
                class="download-icon"
                alt=""
                @click="exportShow = true"
              />
              <div class="download_menu" v-bind:class="{ show: exportShow }">
                <a
                  class="dropdown-item mb-2"
                  style="
                  border: 1px solid rgba(0, 0, 0, 0.4);
                  border-radius: 5px;
                "
                  @click.prevent="exportRecord('csv')"
                  href="javascript:void(0)"
                >
                  {{ $t("export-csv") }}
                </a>
                <a
                  href="javascript:void(0)"
                  class="dropdown-item"
                  style="
                  border: 1px solid rgba(0, 0, 0, 0.4);
                  border-radius: 5px;
                "
                  @click.prevent="exportRecord('pdf')"
                >
                  {{ $t("export-pdf") }}
                </a>
              </div>
            </div>
            <div
              class="col d-flex flex-column justify-content-center align-items-center mb-5 mt-4"
            >
              <p class="text d-flex align-items-center col-gap-1">
                <span
                  v-if="
                    deviceExcursionSummary.device &&
                      deviceExcursionSummary.device.temperature
                  "
                  >{{ deviceExcursionSummary.device.temperature }}&#xb0;C</span
                >
                <span v-else>-</span>
                <span class="rounded-circle circle" v-if="deviceExcursionSummary.device && deviceExcursionSummary.device.temperature">
                  <img :src="isOnExcursion" alt="" />
                </span>
              </p>
              <p class="date">{{ $t("last-updated") }} {{ lastUpdated }}</p>
            </div>
            <div class="row h-100 mb-4">
              <div
                class="col d-flex flex-column justify-content-between"
                style="row-gap: 3rem;"
              >
                <div class="details-container">
                  <p>{{ $t("total-excursion") }}</p>
                  <p class="" v-if="deviceExcursionSummary.tempOverview">
                    {{ deviceExcursionSummary.tempOverview.excursionCount }}
                  </p>
                </div>
                <div class="details-container">
                  <p>{{ $t("average-excursion") }}</p>
                  <p v-if="deviceExcursionSummary.tempOverview">
                    {{ deviceExcursionSummary.tempOverview.average }}
                  </p>
                </div>
              </div>
              <div
                class="col d-flex flex-column justify-content-between"
                style="row-gap: 3rem;"
              >
                <div class="details-container">
                  <p>{{ $t("longest-excursion") }}</p>
                  <p v-if="deviceExcursionSummary.tempOverview">
                    {{ deviceExcursionSummary.tempOverview.highest }}
                  </p>
                  <p v-else>-</p>
                </div>
                <div class="details-container">
                  <p>{{ $t("shortest-excursion") }}</p>
                  <p v-if="deviceExcursionSummary.tempOverview">
                    {{ deviceExcursionSummary.tempOverview.lowest }}
                  </p>
                  <p v-else>-</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-7 col-lg-8">
        <div class="card">
          <div
            class="filter d-flex justify-content-center mt-3 d-flex col-gap-1 align-items-baseline"
          >
            <span class="dater" @click="modal_state = !modal_state">
              <img
                src="../../assets/images/calender.svg"
                alt=""
                class="mr-2"
              />{{ $t("date-range") }}</span
            >
            <div v-show="modal_state">
              <div class="modals" @click="modal_state = false">
                <div @click.stop class="modal_container">
                  <div class="modal_inputs">
                    <p>{{ $t("start-date") }}:</p>
                    <input
                      type="date"
                      name="start"
                      v-model="startdate"
                      :max="maxDate"
                    />
                  </div>
                  <div class="modal_inputs">
                    <p>{{ $t("end-date") }}:</p>
                    <input
                      type="date"
                      name="end"
                      v-model="enddate"
                      :max="maxDate"
                    />
                  </div>

                  <div class="buttons">
                    <button
                      type="submit"
                      name="apply"
                      @click="initialExcursion(true)"
                      :disabled="disableFilter"
                    >
                      {{ $t("apply") }}
                    </button>
                    <button
                      type="close"
                      name="cancel"
                      @click="modal_state = false"
                    >
                      {{ $t("cancel") }}
                    </button>
                  </div>
                  <p
                    v-if="disableFilter"
                    class="text-error font-12 m-0 position-absolute"
                    style="bottom:5px"
                  >
                    {{ $t("start-date-error") }}
                  </p>
                </div>
              </div>
            </div>
            <div class="days d-flex col-gap-2">
              <p
                :class="{ active: active === n }"
                v-for="n in 7"
                :key="n"
                @click="handleClick(n)"
              >
                {{ n }}{{ $t("days-short") }}
              </p>
            </div>
          </div>
          <div id="excursion-barchart" class="col-lg-10">
            <EBarChart :option="barChartData" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="data" class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <DeviceExcursionTable :stats="data" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EBarChart from ".././../components/Echarts/BarChart.vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import DeviceExcursionTable from "../../components/DeviceExcursionTable.vue";
import Loading from "vue-loading-overlay";
import vClickOutside from "v-click-outside";
import jsPDF from "jspdf";
import "jspdf-autotable";
import domtoimage from "dom-to-image";
import greenCheck from "../../assets/images/check.png";
import redAlert from "../../assets/images/alert-triangle.png";

export default {
  name: "DeviceExcursion",
  components: {
    DeviceExcursionTable,
    Loading,
    EBarChart,
  },
  props: {
    // singledevice: {
    //   type: Object,
    //   default: () => {},
    // },
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  data() {
    return {
      startdate: moment().format(),
      starttime: "00:00",
      enddate: moment().format(),
      endtime: "23:59",
      data: [],
      active: 1,
      isLoading: true,
      fullPage: true,
      modal_state: false,
      maxDate: "",
      exportShow: false,
      img: "",
    };
  },
  created() {
    this.initialExcursion();
    let lastSeen = this.singledevice?.stat?.deviceTimeStamp || new Date();
    this.maxDate = new Date(lastSeen).toISOString().slice(0, 10);
  },
  methods: {
    ...mapActions([
      "fetchDeviceExcursions",
      "fetchExcursionSummary",
      "fetchDeviceExcursion",
    ]),
    convertToHoursAndMinutes(value, isString = false) {
      const hours = isString ? value.replace("hours", "") : value;
      const totalMinutes = +hours * 60;
      const hoursValue = Math.floor(totalMinutes / 60);
      const minutesValue = Math.round(totalMinutes % 60);
      const hasMins = minutesValue
        ? `${minutesValue} ${this.$t("minutes")}`
        : "";
      return `${hoursValue} ${this.$t("hours_")} ${hasMins}`;
    },
    handleClick(num) {
      // if (this.active === num) return;
      this.active = num;
      this.initialExcursion();
    },
    initialExcursion(isFilter = false) {
      this.isLoading = true;
      let lastSeen = this.singledevice?.stat?.deviceTimeStamp ?? new Date();

      if (!isFilter) {
        this.enddate = new Date(lastSeen);
        this.startdate = new Date(lastSeen);
        this.startdate.setDate(
          new Date(lastSeen).getDate() - (this.active - 1)
        );
      } else {
        let end = this.enddate;
        let start = this.startdate;
        this.enddate = new Date(end);
        this.startdate = new Date(start);
      }

      // Set the time part for both start and end dates
      this.startdate.setHours(this.starttime.split(":")[0]);
      this.startdate.setMinutes(this.starttime.split(":")[1]);
      this.enddate.setHours(this.endtime.split(":")[0]);
      this.enddate.setMinutes(this.endtime.split(":")[1]);

      this.enddate = moment(this.enddate).format("YYYY-MM-DDTHH:mm:ss");
      this.startdate = moment(this.startdate).format("YYYY-MM-DDTHH:mm:ss");
      
      const params = {
        endDate: this.enddate,
        startDate: this.startdate,
      };

      this.fetchExcursionSummary({ id: this.singledevice.id, params })
        .then(() => {
          this.modal_state && (this.modal_state = false);
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
      // this.fetchDeviceExcursion(this.singledevice.id);
      // this.fetchDeviceExcursions({ params })
    },
    closeExport() {
      if (this.exportShow == true) {
        this.exportShow = false;
      }
    },
    exportRecord(type) {
      if (this.data.length === 0) return;
      this.isLoading = true;
      let head = [
        [
          this.$t("date"),
          this.$t("time"),
          this.$t("min"),
          this.$t("max"),
          `${this.$t("temperature")} (°C)`,
          `${this.$t("duration")} (${this.$t("hours")})`,
        ],
      ];
      let body = [];
      for (let i = 0; i < this.data.length; i++) {
        const { lastupdated, duration, temperature } = this.data[i];
        const { minTemp, maxTemp } = this.singledevice.settings;
        const [date, time] = moment(lastupdated)
          .format("DD/MM/YYYY, hh:mm a")
          .split(",");
        body.push([date, time, minTemp, maxTemp, temperature, duration]);
      }
      if (type == "csv") {
        body.unshift(head);
        body = body.map((e) => e.join(",")).join("\n");
        let csvContent = "data:text/csv;charset=utf-8," + body;
        csvContent = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", csvContent);
        link.setAttribute(
          "download",
          `${this.singledevice.settings.name}_excursions.csv`
        );
        document.body.appendChild(link); // Required for FF
        setTimeout(() => {
          link.click();
          this.isLoading = false;
        }, 500);
      }

      if (type == "pdf") {
        var barchart = document.getElementById("excursion-barchart");
        var piechart = document.getElementById("excursion-piechart");

        var temp =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACSSURBVHgBtZLhDUAwEIWvYgAj2MAKHcEINmAUIxjBBmzABtjABueV/tG0XCW+5OXS5L72LinRHzBzjQymxoqaL1pbta8vCfg5siIjstuzWD5RSvVWpmgZ45Yo2ScZzE8vp2Hv3HOhWDDuxHcmqVixn8bt9e2sA/cWEnklPxu9gfEyZHFGNuecJJhGpLN/uxWLMRw/e4KbUYJBSgAAAABJRU5ErkJggg==";
        var excursion =
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAYAAAB2HjRBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACmSURBVHgBlZEBEYMwDEVTFFTKJETCJDAHlTAJtYCC4WASNge7KRgOshR+70K5A/Lu/vUS8smnEDWISFQ9VUxe1NTLQiYvanrA/PMaI4wvnLw33zX1FedNNZl6dxtD5aI+6GcbvZnj2kyyJqPPNjpeZkmhDpow7xDChH7ZPGidkOirute5o0+ao6su2NbTWUz0evuRPGBzYWyfdSf8A86RvJhfuIn8B3iJ1TkqATN7AAAAAElFTkSuQmCC";

        var imgUrl =
          "data:image/png;base64,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";

        var companyImg = this.businessprofile.image;
        var c = document.createElement("canvas");
        var img = document.createElement("img");
        img.crossOrigin = "anonymous";
        img.src = companyImg;

        const {
          averageExcursion: avgExcursion,
          longestExcursion: maxExcursion,
          shortestExcursion: minExcursion,
          totalExcursion,
        } = this.deviceexcursions;
        var doc = new jsPDF();

        setTimeout(() => {
          c.height = img.naturalHeight;
          c.width = img.naturalWidth;
          var ctx = c.getContext("2d");

          ctx.drawImage(img, 0, 0, c.width, c.height);
          var base64String = c.toDataURL("image/png");
          var base64Img = base64String.replace(
            /^data:image\/(png|jpg);base64,/,
            ""
          );
          doc.addImage(base64Img, "JPEG", 175, 5, 25, 11);
        }, 1000);

        doc.addImage(imgUrl, "JPEG", 15, 8, 25, 8);
        doc.setFont("times");
        doc.setDrawColor(225, 231, 236);
        doc.line(0, 22, 215, 22); //horizontal

        doc.setFontSize(12);
        doc.setTextColor(51, 51, 51);
        doc.text(15, 32, this.$t("qualityAssuranceReport"));
        doc.setFontSize(10);
        doc.setTextColor(134, 147, 165);
        doc.text(
          175,
          32,
          `${moment()
            .startOf("day")
            .format("ddd Do MMM, YYYY")}`
        );
        doc.setDrawColor(134, 147, 165);

        doc.setFillColor(255, 255, 255);
        doc.roundedRect(15, 40, 185, 70, 1, 1, "FD");

        doc.setTextColor(34, 34, 34);
        doc.text(20, 48, this.$t("reportDetails"));

        doc.setTextColor(134, 147, 165);

        doc.text(20, 56, this.$t("deviceName"));
        doc.text(20, 64, this.$t("deviceTag"));
        doc.text(20, 72, this.$t("startDate"));
        doc.text(20, 80, this.$t("endDate"));
        doc.text(20, 88, this.$t("description"));

        doc.setTextColor(34, 34, 34);
        doc.text(50, 56, `${this.singledevice.settings.name}`);
        doc.text(50, 64, `${this.singledevice.deviceTag}`);
        doc.text(
          50,
          72,
          `${moment(
            `${this.startdate} ${this.starttime}`,
            "YYYY-M-D H:m",
            true
          ).format("ddd, MMM Do YYYY, hh:mm a")}`
        );
        doc.text(
          50,
          80,
          `${moment(
            `${this.enddate} ${this.endtime}`,
            "YYYY-M-D H:m",
            true
          ).format("ddd, MMM Do YYYY, hh:mm a")}`
        );

        doc.text(
          50,
          88,
          `${this.$t("tempMonitoring")} ${this.singledevice.settings.name}`
        );

        doc.setFillColor(255, 255, 255);
        doc.roundedRect(15, 120, 185, 100, 1, 1, "FD");

        doc.circle(19, 234, 4);
        doc.setFillColor(64, 74, 87);
        doc.circle(19, 234, 2, "FD");
        doc.addImage(temp, "JPEG", 17.5, 232.6, 3, 3);
        doc.line(23, 234, 66, 234); //horizontal
        doc.text(24, 233, this.$t("temperatureChartSummary"));
        doc.text(25, 240, this.$t("chartSummaryDescription"));

        doc.setFillColor(246, 225, 225);
        doc.setDrawColor(253, 77, 77);
        doc.setTextColor(253, 77, 77);
        doc.roundedRect(15, 250, 80, 17, 2, 2, "FD");
        doc.setFillColor(253, 77, 77);
        doc.circle(24, 258, 2, "FD");
        doc.addImage(temp, "JPEG", 22.5, 256.6, 3, 3);
        doc.text(
          28,
          259,
          `${this.$t("maxTemperature")} : ${
            this.singledevice.settings.maxTemp
          }°C`
        );

        doc.setFillColor(255, 239, 203);
        doc.setDrawColor(250, 188, 45);
        doc.setTextColor(250, 188, 45);
        doc.roundedRect(105, 250, 80, 17, 2, 2, "FD");
        doc.setFillColor(250, 188, 45);
        doc.circle(114, 258, 2, "FD");
        doc.addImage(temp, "JPEG", 112.5, 256.6, 3, 3);
        doc.text(
          118,
          259,
          `${this.$t("minTemperature")} : ${
            this.singledevice.settings.minTemp
          }°C`
        );

        doc.setFillColor(214, 245, 222);
        doc.setDrawColor(40, 168, 74);
        doc.setTextColor(40, 168, 74);
        doc.roundedRect(15, 275, 80, 17, 2, 2, "FD");
        doc.setFillColor(40, 168, 74);
        doc.circle(24, 283, 2, "FD");
        doc.addImage(excursion, "JPEG", 22.5, 281.6, 3, 3);
        doc.text(28, 284, `${this.$t("numOfExcursions")} : ${totalExcursion}`);

        doc.setFillColor(202, 245, 214);
        doc.setDrawColor(2, 43, 13);
        doc.setTextColor(2, 43, 13);
        doc.roundedRect(105, 275, 80, 17, 2, 2, "FD");
        doc.setFillColor(2, 43, 13);
        doc.circle(114, 283, 2, "FD");
        doc.addImage(excursion, "JPEG", 112.5, 281.6, 3, 3);

        doc.text(
          118,
          284,
          `${this.$t("longestExcursionDuration")} : ${maxExcursion}`
        );

        setTimeout(() => {
          domtoimage
            .toPng(barchart)
            .then(function(dataUrl) {
              doc.addImage(dataUrl, "png", 20, 125, 175, 90);
            })
            .then(() => {
              doc.addPage();
              doc.setFillColor(218, 226, 239);
              doc.setDrawColor(105, 137, 194);
              doc.setTextColor(105, 137, 194);
              doc.roundedRect(15, 10, 80, 17, 2, 2, "FD");
              doc.setFillColor(105, 137, 194);
              doc.circle(24, 18, 2, "FD");
              doc.addImage(excursion, "JPEG", 22.5, 16.6, 3, 3);

              doc.text(
                28,
                19,
                `${this.$t("shortestExcursionDuration")} : ${minExcursion}`
              );

              doc.setFillColor(238, 243, 246);
              doc.setDrawColor(183, 195, 205);
              doc.setTextColor(64, 74, 87);
              doc.roundedRect(105, 10, 80, 17, 2, 2, "FD");
              doc.setFillColor(134, 147, 165);
              doc.circle(114, 18, 2, "FD");
              doc.addImage(excursion, "JPEG", 112.5, 16.6, 3, 3);

              doc.text(
                118,
                19,
                `${this.$t("averageExcursionDuration")} : ${avgExcursion}`
              );

              domtoimage.toPng(piechart).then(function(dataUrl) {
                // doc.setFillColor(255, 255, 255);
                // doc.roundedRect(14, 39, 186, 92, 1, 1, "FD");
                doc.addImage(dataUrl, "png", 13, 40, 176, 140);
              });

              setTimeout(() => {
                doc.save(
                  `${this.singledevice.settings.name}_${this.singledevice.deviceTag}.pdf`
                );
                this.isLoading = false;
              }, 1000);
            });
        }, 1000);
      }
      this.exportShow = false;
    },
    getTotalHoursFromDuration(duration) {
      const match = duration.match(/(\d+)hrs (\d+)mins/);

      if (!match) {
        return 0; // Invalid duration format, return 0
      }

      const hours = parseInt(match[1]) || 0; // Parse hours as an integer, default to 0 if not provided
      const minutes = parseInt(match[2]) || 0; // Parse minutes as an integer, default to 0 if not provided

      // Calculate total hours, rounding to two decimal places
      const totalHours = parseFloat((hours + minutes / 60).toFixed(2));

      return totalHours;
    },
  },
  computed: {
    ...mapGetters([
      "deviceexcursions",
      "businessprofile",
      "singledevice",
      "deviceExcursionSummary",
    ]),
    pieChartData() {
      let stable = 0,
        critical = 0;
      this.data?.forEach((item) => {
        if (item.status === "critical") {
          critical++;
        }
        if (item.status === "good") {
          stable++;
        }
      });
      const dataSet = [
        {
          label: this.$t("stable"),
          value: stable.toString(),
          color: "#C6E4E1",
        },
        {
          label: this.$t("critical"),
          value: critical.toString(),
          color: "#EB5757",
        },
      ];
      return dataSet;
    },
    lastUpdated() {
      return this.deviceExcursionSummary?.device?.lastUpdated
        ? moment(this.deviceExcursionSummary?.device?.lastUpdated).format(
            "MMM Do YYYY, hh:mm a"
          )
        : "-";
    },
    barChartData() {
      const xAxis = {
        type: "category",
        data: [
          "0 - 1",
          "1 - 2",
          "2 - 3",
          "3 - 4",
          "4 - 5",
          `${this.$t("above")} 5`,
        ],
        axisTick: {
          alignWithLabel: true,
        },
        axisLabel: {
          interval: 0,
          // rotate: 90,
          lineHeight: 10,
          height: 40,
          lineOverflow: "truncate",
          align: "center",
          formatter: "{value} Hrs",
        },
        name: this.$t("duration_hours"),
        nameLocation: "center",
        nameGap: 30,
      };
      const yAxis = {
        type: "value",
        label: this.$t("number_of_excursions"),
        axisLabel: {
          fontFamily: "Poppins",
          fontSize: 14,
        },
        name: this.$t("number_of_excursions"),
        nameLocation: "center",
        nameGap: 40,
      };

      const seriesData = xAxis.data.map(() => 0);

      this.data?.forEach((item) => {
        const hrs = this.getTotalHoursFromDuration(item.duration);
        switch (true) {
          case hrs > 0 && hrs <= 1:
            seriesData[0]++;
            break;
          case hrs > 1 && hrs <= 2:
            seriesData[1]++;
            break;
          case hrs > 2 && hrs <= 3:
            seriesData[2]++;
            break;
          case hrs > 3 && hrs <= 4:
            seriesData[3]++;
            break;
          case hrs > 4 && hrs <= 5:
            seriesData[4]++;
            break;
          default:
            seriesData[5]++;
            break;
        }
      });

      const series = [
        {
          data: seriesData,
          type: "bar",
          name: this.$t("device_excursions"),
          color: "#dee2eb",
          barWidth: "90%",
        },
      ];

      const tooltip = {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      };

      return { legend: {}, tooltip, xAxis, yAxis, series };
    },

    disableFilter() {
      return (
        moment(this.startdate).isAfter(this.enddate) ||
        moment(this.startdate).isSame(this.enddate)
      );
    },
    isOnExcursion() {
      let img = "";
      const { temperature: temp } = this.deviceExcursionSummary?.device;
      const {
        mintemp: minTemp,
        maxtemp: maxTemp,
      } = this.deviceExcursionSummary.tempOverview;
      if (!temp) return redAlert;
      const isExcursion = temp <= minTemp || temp >= maxTemp;
      img = temp && isExcursion ? redAlert : greenCheck;
      return img;
    },
  },
  watch: {
    deviceExcursionSummary: {
      handler: function() {
        const dataArray = this.deviceExcursionSummary?.tempOverview?.excursions.map(
          ({
            temperature,
            status = "critical",
            duration,
            end,
            lastExcursionTimeStamp,
          }) => ({
            temperature,
            status,
            duration,
            lastupdated: end || lastExcursionTimeStamp,
          })
        );
        this.data = dataArray;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.display-info {
  /* margin-top: 20px; */
  /* height: 221px; */
  padding: 10px;
}
.details-container :first-child {
  font-weight: 500;
  font-size: 16px;
  color: #5e6a79;
}

.details-container :last-child {
  font-weight: 500;
  font-size: 24px;
  margin-bottom: 0;
}
.text {
  font-weight: 600;
  font-size: 36px;
}
.date {
  font-weight: 300;
  font-size: 11px;
}
.circle {
  height: 40px;
  width: 40px;
  background: #ffffff;
  box-shadow: 0px 4px 8px -1px rgba(0, 0, 0, 0.2);
  position: relative;
  justify-content: center;
  align-items: center;
  display: inline-flex;
}

.download-icon {
  position: absolute;
  right: 15px;
  top: 10px;
  cursor: pointer;
}

.charts {
  display: flex;
}
.charts :first-child {
  flex-basis: 70%;
}

.days p {
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
}

.days p.active {
  background: #213e7a;
  color: white;
  cursor: default;
}

.dater {
  cursor: pointer;
  font-weight: 600;
  font-size: 18px;
  align-items: center;
  display: flex;
  justify-content: center;
}

.dater:hover {
  color: #213e7a;
}

.modals {
  position: absolute;
  z-index: 1;
  left: 50px;
  top: 80px;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.modal_container {
  position: relative;
  background-color: #fefefe;
  /* margin: 15% auto; */
  padding: 30px 40px;
  border: 1px solid lightgray;
  width: 362px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  animation-duration: 0.6s;
  animation-name: fadeIn;
  transition: all 0.4s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal_inputs {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  width: 100%;
}

.modal_inputs p {
  text-align: center;
  margin-right: 10px;
  margin: auto 0px;
  font-weight: 700;
  font-size: 18px;
  /* width: 110%; */
  white-space: nowrap;
}

.modal_inputs input {
  padding: 10px;
  font-size: 19px;
  border: 1px solid lightgray;
  border-radius: 5px;
  margin-left: 10px;
  color: rgb(46, 46, 46);
}

.modal_inputs input:focus {
  outline: none;
}

.buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}

.buttons button {
  padding: 10px 32px;
  font-size: 18px;
  border: 1px solid #213e7a;
  border-radius: 25px;
  background: #213e7a;
  color: white;
  margin-left: 10px;
  cursor: pointer;
  transition: all 0.4s ease-in-out;
  /* width: 120%; */
}

.buttons button:not(:disabled):hover {
  background: white;
  color: #213e7a;
  transition: all 0.4s ease-in-out;
  transform: scale(0.95);
}

.buttons button:last-child {
  border: 1px solid #213e7a;
  background: white;
  color: #213e7a;
  margin-right: 10px;
}

.buttons button:last-child:hover {
  background: #213e7a;
  color: white;
}

.buttons button:focus {
  outline: none;
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.download_menu {
  position: absolute;
  top: 41px;
  right: 0;
  z-index: 1000;
  display: none;
  padding: 0.5rem;
  margin: 0.125rem 0 0;
  font-size: 0.875rem;
  color: #6a7a8c;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #e9ecef;
  border-radius: 2px;
}
.show {
  display: block;
}
</style>

<i18n>
  {
  "en": {
    "date-range": "Date Range",
    "start-date": "Start date",
    "end-date": "End date",
    "apply": "Apply",
    "cancel": "Cancel",
    "start-date-error": "Start Date cannot be greater or equal to End Date",
    "days-short": "D"
  },
  "fr": {
    "date-range": "Plage de dates",
    "start-date": "Date de début",
    "end-date": "Date de fin",
    "apply": "Appliquer",
    "cancel": "Annuler",
    "start-date-error": "La date de début ne peut pas être supérieure ou égale à la date de fin",
    "days-short": "J"
  },
  "sw": {
    "date-range": "Muda wa Tarehe",
    "start-date": "Tarehe ya kuanza",
    "end-date": "Tarehe ya mwisho",
    "apply": "Tumia",
    "cancel": "Ghairi",
    "start-date-error": "Tarehe ya kuanza haiwezi kuwa sawa au kubwa kuliko Tarehe ya mwisho",
    "days-short": "S"
  }
}
</i18n>
